export default __webpack_public_path__ + "static/media/logo-white.1f62df71.svg";